import * as l from "react";
const e = (t) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M16.965 5.758l-.283.898a1.352 1.352 0 00-.664.166 1.147 1.147 0 00-.425.454c-.108.199-.22.487-.337.865l-2.48 8.164c-.118.37-.176.657-.176.86 0 .331.135.57.405.717.27.146.587.22.952.22l-.254.898H8.195l.284-.898c.468 0 .8-.129.996-.386.195-.257.364-.623.507-1.099l2.5-8.154c.118-.41.176-.697.176-.86 0-.377-.119-.623-.356-.737a2.28 2.28 0 00-.786-.21l.283-.898h5.166z",
      fill: "#2d6ded"
    }
  )
), a = e;
export {
  a as default
};
